import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { systemLogAreaOptionActions } from '../state/system-logs-area-select-option.actions';
import { systemLogAreaOptionSelectors } from '../state/system-logs-area-select-option.reducer';
import { SystemLogAreaOption } from '../system-logs-area-option.interface';

@Directive({
    selector: '[ndtSystemLogAreaSelect]',
    standalone: false
})
export class SystemLogAreaSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<SystemLogAreaOption>,
      private statusService: NgrxEagerSelectService<AppState, SystemLogAreaOption>
   ) {}

   ngAfterViewInit(): void {
      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            systemLogAreaOptionActions,
            systemLogAreaOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('systemLogAreaId', this.trigger);
            },
            undefined
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
